import { IS_REF_MOBILE } from "../../../utils/refViewport";
import { MY_BETS_LIMIT, scrollToMyBets } from "../../../utils/casinoMyBets";

/**
 * Reference shell of the "five-cricket" casino pages (superover, superover2, cricketv3):
 *   .detail-page-container > .center-main-container >
 *     .center-content > .casino-container > .casino-table.{tableClass} + {afterTable}
 *     .right-sidebar > {rightSide}  (desktop: data-simplebar root, content in one wrapper div;
 *                                    reference "mobile" (<1280 at load): plain div, then .market-show-icon)
 * Unlike the generic CasinoTableLayout, these pages have no .casino-right-sidebar and put
 * the Last Result block after .casino-table (superover, superover2) — hence the afterTable slot.
 */
export default function FiveCricketLayout({ tableClass, tableAttrs, children, afterTable, rightSide, betCount = 0 }) {
  return (
    <div className="detail-page-container">
      <div className="center-main-container">
        <div className="center-content">
          <div className="casino-container">
            <div className={`casino-table ${tableClass}`} {...tableAttrs}>
              {children}
            </div>
            {afterTable}
          </div>
        </div>
        {IS_REF_MOBILE ? (
          <>
            <div className="right-sidebar">{rightSide}</div>{" "}
            <div
              className="market-show-icon d-none-desktop"
              onClick={() => scrollToMyBets("my-game-bets")}
            >
              {/* counts what the card lists (latest 10), not every bet */}
              <div className="bet-cnt">{Math.min(betCount, MY_BETS_LIMIT)}</div>{" "}
              <div className="bet-title">Bets</div>
            </div>
          </>
        ) : (
          <div className="right-sidebar" data-simplebar="init">
            <div>{rightSide}</div>
          </div>
        )}
      </div>
    </div>
  );
}
